module.exports = __webpack_public_path__ + "static/media/search.94f2a3fe.svg";